export default "/assets/images/dark-moss-sm.jpg?fbe91d9411cf0c472a511667885eba06";